// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.

export const ADD_ASSET_DEVICE_ACTIVE = "ADD_ASSET_DEVICE_ACTIVE";
export const ADD_ASSET_DEVICE_INACTIVE = "ADD_ASSET_DEVICE_INACTIVE";
